import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { theme } from "../../utils/theme";

const ReadMailContent = styled("div")`
  display: grid;
  grid-template-columns: auto 60% auto;
  margin-top: 2rem;

  @media (max-width: 600px) {
    grid-template-columns: auto 100% auto;
  }

  // Tablets
  @media only screen and (min-width: 768px) {
    grid-template-columns: auto 100% auto;
  }

  // Laptops & Desktops
  @media only screen and (min-width: 992px) {
    grid-template-columns: auto 60% auto;
  }
`;

const Wrapper = styled("div")`
  border-radius: 1rem;
  border: 1px solid #ddd;
`;

const MailHead = styled("div")`
  background-color: ${theme.colors.primary};
  color: #fff;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 1rem;
`;

const MailBody = styled("div")`
  padding: 1rem;
  color: ${theme.colors.secondary};

  .subject {
    padding: 1rem 0;
    border-bottom: 1px solid gray;
  }

  .mailtext {
    padding: 1rem 0;
  }

  span {
    font-weight: bold;
  }
`;

const Sender = styled("div")`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
  border-bottom: 1px solid gray;

  @media (max-width: 600px) {
    gap: 1rem;
  }
`;

const ReadMail = ({ sender, date, subject, mailcontent }) => {
  const navigate = useNavigate();
  return (
    <ReadMailContent>
      <div></div>
      <Wrapper>
        <MailHead>
          <button onClick={() => navigate(-1)}>Back</button>
        </MailHead>
        <MailBody>
          <Sender>
            <div className="senderMail">
              <span>Sender:</span> {sender}
            </div>
            <div className="date">
              <span>Date:</span> {date}
            </div>
          </Sender>
          <div className="subject">
            <span>Subject:</span> {subject}
          </div>
          <div className="mailtext">
            <span>Mail:</span> {mailcontent}
          </div>
        </MailBody>
      </Wrapper>
      <div></div>
    </ReadMailContent>
  );
};

export default ReadMail;
